export function nomeArquivoDoContentDisposition(
  header: unknown,
  padrao: string
): string {
  if (typeof header !== "string") return padrao;

  const nome = header.match(/filename="?([^";]+)"?/i)?.[1]?.trim();

  return nome || padrao;
}
